<script>import { flip } from "svelte/animate";
import clsx from "clsx";
import { portal } from "./actions/portal.js";
import { reducedMotion } from "./stores/reduced-motion.js";
import { appear } from "./transitions/appear.js";
import { reoccurrence } from "./actions/reoccurrence.js";
export let toaster;
let className = void 0;
export { className as class };
export let position = "bottom-right";
export let gap = "md";
export let inset = "md";
export let portalTarget = void 0;
export let transitions = "all";
export let reocurrenceDuration = 300;
let reocurrences = [];
</script>

<div
  class={clsx('toasts', position, `gap-${gap}`, `inset-${inset}`, className)}
  use:portal={portalTarget}
>
  {#each $toaster as toast, i (toast.id)}
    <div
      animate:flip={{ duration: $reducedMotion ? 0 : 200 }}
      on:pointerenter={toaster.pauseAll}
      on:pointerleave={toaster.resumeAll}
      style="will-change: transform; pointer-events: auto; z-index: {999 - i};"
    >
      <div
        data-reocurring-toast={reocurrences.includes(toast.id)}
        use:reoccurrence={{
          toast,
          in: () => (reocurrences = [...reocurrences, toast.id]),
          out: () => (reocurrences = reocurrences.filter((id) => id !== toast.id)),
          duration: reocurrenceDuration
        }}
        class:reocurring={['all', 'reocurrence-only'].includes(transitions)}
        transition:appear|global={{
          position,
          duration: ['all', 'appear-only'].includes(transitions) ? 300 : 0
        }}
      >
        <slot {toast} {i} />
      </div>
    </div>
  {/each}
</div>

<style>
  .reocurring {
    will-change: transform;
    transition: transform 0.8s cubic-bezier(0.2, 1, 0.8, 1);
  }

  .reocurring[data-reocurring-toast='true'] {
    transform: scale(1.05);

    transition: transform 0.1s cubic-bezier(0.2, 1, 0.8, 1);
  }

  .toasts {
    pointer-events: none;
    position: fixed;
    z-index: 99999;

    display: flex;
    flex-direction: var(--toasts-flex-direction);
    align-items: var(--toasts-align-items);
    gap: var(--toasts-gap);
    inset: var(--toasts-inset);
  }

  .toasts.top-left {
    --toasts-flex-direction: column;
    --toasts-align-items: flex-start;
  }

  .toasts.top-center {
    --toasts-flex-direction: column;
    --toasts-align-items: center;
  }

  .toasts.top-right {
    --toasts-flex-direction: column;
    --toasts-align-items: flex-end;
  }

  .toasts.bottom-left {
    --toasts-flex-direction: column-reverse;
    --toasts-align-items: flex-start;
  }

  .toasts.bottom-center {
    --toasts-flex-direction: column-reverse;
    --toasts-align-items: center;
  }

  .toasts.bottom-right {
    --toasts-flex-direction: column-reverse;
    --toasts-align-items: flex-end;
  }

  .toasts.gap-sm {
    --toasts-gap: 0.5rem;
  }

  .toasts.gap-md {
    --toasts-gap: 1rem;
  }

  .toasts.gap-lg {
    --toasts-gap: 1.5rem;
  }

  .toasts.gap-xl {
    --toasts-gap: 2rem;
  }

  .toasts.inset-sm {
    --toasts-inset: 0.5rem;
  }

  .toasts.inset-md {
    --toasts-inset: 1rem;
  }

  .toasts.inset-lg {
    --toasts-inset: 1.5rem;
  }

  .toasts.inset-xl {
    --toasts-inset: 2rem;
  }
</style>
